/**
 * Checkbox-kind of selection which:
 * - forces that if child is selected, parent should also be selected,
 * - forces that if all children deselected parent also deselected
 */
import { getNodeId } from '../store/actionHandlers/common/adapterActions';
import HierarchySelectionBase from './common/HierarchySelectionBase';

export default class TopHierarchySelection extends HierarchySelectionBase {
  toggleNodeSelected(oldTreeState, nodeId, { adapter }) {
    if (this.nodeIsSelected(oldTreeState, nodeId)) {
      return {
        ...oldTreeState,
        ...deselectNode(oldTreeState, nodeId, adapter),
      };
    }
    return {
      ...oldTreeState,
      ...selectNode(oldTreeState, nodeId, adapter),
    };
  }
}

function selectNode(
  {
    models,
    parents,
    selectionStatuses: oldSelectionStatuses,
    selection: oldSelection,
  },
  nodeId,
  adapter,
) {
  const selectionStatuses = { ...oldSelectionStatuses };

  selectionStatuses[nodeId] = true;

  let parentId = parents[nodeId];
  while (parentId) {
    selectionStatuses[parentId] = true;
    parentId = parents[parentId];
  }

  return {
    selectionStatuses,
    selection: collectSelection(
      selectionStatuses,
      models,
      oldSelection,
      adapter,
    ),
  };
}

function deselectNode(
  {
    models,
    children,
    parents,
    selectionStatuses: oldSelectionStatuses,
    selection: oldSelection,
  },
  nodeId,
  adapter,
) {
  const selectionStatuses = { ...oldSelectionStatuses };

  deselect(nodeId);

  return {
    selectionStatuses,
    selection: collectSelection(
      selectionStatuses,
      models,
      oldSelection,
      adapter,
    ),
  };

  function deselect(id, isSkipChildren = false) {
    delete selectionStatuses[id];
    if (!isSkipChildren && children[id]) {
      for (const childId of children[id]) {
        deselect(childId, isSkipChildren);
      }
    }

    if (
      parents[id] &&
      !children[parents[id]].some(key => selectionStatuses[key])
    ) {
      deselect(parents[id], true);
    }
  }
}

function collectSelection(selectionStatuses, models, oldSelection, adapter) {
  const oldSelectionById = oldSelection.reduce((hash, oldNode) => {
    hash[getNodeId(adapter, oldNode)] = oldNode;
    return hash;
  }, {});

  return Object.keys(selectionStatuses)
    .map(id => models[id] || oldSelectionById[id])
    .filter(node => !!node);
}
